//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface Ubigeo {
    code: string;
    name: string;
    department: string;
}

export interface UbigeoGroup {
    id: string;
    label: string;
    codes: string[];
}

export interface UbigeosResponse {
    ubigeos: Ubigeo[];
    groups: UbigeoGroup[];
}

export interface IUbigeosClient {
    /**
     * Obtener catálogo de UBIGEOS con estructura jerárquica de 2 niveles.
     * @return Catálogo de UBIGEOS
     */
    getUbigeos(): Observable<UbigeosResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class UbigeosClient implements IUbigeosClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Obtener catálogo de UBIGEOS con estructura jerárquica de 2 niveles.
     * @return Catálogo de UBIGEOS
     */
    getUbigeos(): Observable<UbigeosResponse> {
        let url_ = this.baseUrl + "/hub/ubigeos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUbigeos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUbigeos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UbigeosResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UbigeosResponse>;
        }));
    }

    protected processGetUbigeos(response: HttpResponseBase): Observable<UbigeosResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers && response.headers.keys) {
            for (let i = 0; i < response.headers.keys().length; i++) {
                _headers[response.headers.keys()[i]] = response.headers.get(response.headers.keys()[i]);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let resultData200: any = null;
                let resultData200StatusCode: string | undefined = (status === 200) ? "OK" : undefined;
                try {
                    resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                } catch (e) {
                    throw new SyntaxError("Could not parse the server response: " + _responseText);
                }
                return _observableOf(UbigeosResponse.fromJS(resultData200) as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(undefined as any);
    }
}

export class UbigeosResponse implements UbigeosResponse {
    ubigeos!: Ubigeo[];
    groups!: UbigeoGroup[];

    static fromJS(data: any): UbigeosResponse {
        data = typeof data === 'object' ? data : {};
        const result = new UbigeosResponse();
        result.ubigeos = data["ubigeos"] ? data["ubigeos"].map((x: any) => Ubigeo.fromJS(x)) : [];
        result.groups = data["groups"] ? data["groups"].map((x: any) => UbigeoGroup.fromJS(x)) : [];
        return result;
    }
}

export class Ubigeo implements Ubigeo {
    code!: string;
    name!: string;
    department!: string;

    static fromJS(data: any): Ubigeo {
        data = typeof data === 'object' ? data : {};
        const result = new Ubigeo();
        result.code = data["code"] !== undefined ? data["code"] : "";
        result.name = data["name"] !== undefined ? data["name"] : "";
        result.department = data["department"] !== undefined ? data["department"] : "";
        return result;
    }
}

export class UbigeoGroup implements UbigeoGroup {
    id!: string;
    label!: string;
    codes!: string[];

    static fromJS(data: any): UbigeoGroup {
        data = typeof data === 'object' ? data : {};
        const result = new UbigeoGroup();
        result.id = data["id"] !== undefined ? data["id"] : "";
        result.label = data["label"] !== undefined ? data["label"] : "";
        result.codes = data["codes"] ? data["codes"].map((x: any) => x) : [];
        return result;
    }
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
